import { Component, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';

import { UserService } from '../../core/services/user.service';
import { CustomizableBanner, CustomizableBannerSpotNamesEnum } from '../../models/customizable-banner';
import { LogoComponent } from '../../ui-kit/logo/logo.component';
import { CustomizableBannerComponent } from '../customizable-banner/customizable-banner.component';

@Component({
  selector: 'app-full-page-promo-banner',
  templateUrl: './full-page-promo-banner.component.html',
  styleUrls: ['./full-page-promo-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LogoComponent, MatButtonModule, RouterLink, CustomizableBannerComponent],
})
export class FullPagePromoBannerComponent {
  private userService = inject(UserService);
  private router = inject(Router);

  @ViewChild(CustomizableBannerComponent) customizableBannerComponent: CustomizableBannerComponent;
  customizableBannerSpotNames = CustomizableBannerSpotNamesEnum;
  banner: CustomizableBanner;

  clickCloseButton(): void {
    if (this.banner) {
      const ctaName = 'Close';
      this.userService.trackUserActions(`Banner "${this.banner.name}", click on ${ctaName}`, this.router.url);
      this.customizableBannerComponent.closeBanner(this.banner, ctaName).subscribe();
    }
  }
}
